import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

const axiosConfig = {
    headers: {
        "Content-Template": "application/json",
    },
    withCredentials: true,
};

const axiosFormDataConfig = {
    headers: {
        "Content-Template": "multipart/form-data",
    },
    withCredentials: true,
};

const handleAxiosError = (err, rejectWithValue) => {
    if (err.message === "Network Error") {
        return rejectWithValue({ message: "Network Error" });
    }
    return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
    );
};

export const createCertificateTemplate = createAsyncThunk(
    "certificateTemplate/createCertificateTemplate",
    async (templateData, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('certificate_type_id', templateData.certificate_type_id);
            formData.append('certificate_entity_id', templateData.entity_id);
            formData.append('name', templateData.name);
            formData.append('is_version_available', templateData.is_version_available);
            formData.append('template', templateData.template);
            formData.append('header_logo', templateData.header_logo);
            formData.append('footor_logo', templateData.footor_logo);
            formData.append('background_image', templateData.background_image);

            const response = await axios.post(
                `${PUBLIC_BASE_URL}/certificate-templates/create-certificate-template`,
                formData,
                axiosFormDataConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getAllCertificateTemplates = createAsyncThunk(
    "certificateTemplate/getAllCertificateTemplates",
    async ({ skip, limit, search }, { rejectWithValue }) => {
        try {

            const params = {
                ...(skip != null && { skip }),
                ...(limit != null && { limit }),
                ...(search?.trim() && { search }),
            };

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-templates`,
                {
                    ...axiosConfig,
                    params,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const updateCertificateTemplate = createAsyncThunk(
    "certificateTemplate/updateCertificateTemplate",
    async (templateData, { rejectWithValue }) => {
        try {

            const formData = new FormData();
            formData.append('id', templateData.id);

            if (templateData.name) {
                formData.append('name', templateData.name);
            }
            if (templateData.certificate_type_id) {
                formData.append('certificate_type_id', templateData.certificate_type_id);
            }
            if (templateData.template) {
                formData.append('template', templateData.template);
            }
            if (templateData.header_logo) {
                formData.append('header_logo', templateData.header_logo);
            }
            if (templateData.footor_logo) {
                formData.append('footor_logo', templateData.footor_logo);
            }
            if (templateData.background_image) {
                formData.append('background_image', templateData.background_image);
            }
            if (templateData.status !== undefined) {
                formData.append('status', templateData.status);
            }

            const response = await axios.put(
                `${PUBLIC_BASE_URL}/certificate-templates/update-certificate-template-info`,
                formData,
                axiosConfig
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getActiveCertificateTemplates = createAsyncThunk(
    "certificateTemplate/getActiveCertificateTemplates",
    async (_, { rejectWithValue }) => {
        try {

            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-templates/active-certificate-templates`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getCertificateTemplateById = createAsyncThunk(
    "certificateTemplate/getCertificateTemplateById",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-templates/${id}`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getCertificateTemplatesByType = createAsyncThunk(
    "certificateTemplate/getCertificateTemplatesByType",
    async ({ id }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-templates/get-active-courses-by-certificate-type-and-certificate-entity-code/${id}`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);

export const getCertificateTemplatesByTypeAndEntity = createAsyncThunk(
    "certificateTemplate/getCertificateTemplatesByTypeAndEntity",
    async ({ typeId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${PUBLIC_BASE_URL}/certificate-templates/get-active-courses-by-certificate-type-and-certificate-entity-code/${typeId}`,
                {
                    ...axiosConfig,
                }
            );
            return response.data;
        } catch (err) {
            return handleAxiosError(err, rejectWithValue);
        }
    }
);